module.exports = __webpack_public_path__ + "img/compu-meeting-coordination-hover.44e7caf5.svg";